import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSeo } from '@/lib/seo';

export default function NotFound() {
  useSeo({ title: 'Página não encontrada' });
  return (
    <div className="container-x flex min-h-[60vh] flex-col items-center justify-center py-20 text-center" data-testid="not-found">
      <div className="font-mono text-sm text-primary">404</div>
      <h1 className="mt-2 text-3xl font-semibold">Página não encontrada</h1>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">O endereço pode estar incorreto ou o conteúdo foi removido.</p>
      <Button asChild className="btn-glow mt-6"><Link to="/"><Compass /> Voltar ao início</Link></Button>
    </div>
  );
}
